import { useTranslation } from "react-i18next";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { asTitle } from "utils/Utils";

export type InfoDialogProps = {
	info: string;
	onClose: () => void;
};

const InfoDialog: React.FC<InfoDialogProps> = (props: InfoDialogProps) => {
	const { t } = useTranslation();

	return (
		<Dialog onClose={props.onClose} open={true}>
			<DialogTitle>{asTitle(t("info"))}</DialogTitle>
			<DialogContent>
				<DialogContentText>
					<span dangerouslySetInnerHTML={{ __html: props.info }} />
				</DialogContentText>
			</DialogContent>
		</Dialog>
	);
};

export default InfoDialog;
